import { formatMoney } from 'src/utils/formatMoney';
import QuoteNotes from './QuoteNotes';
import { useLocalization } from 'src/utils/useLocalization';
import { formatDate, formatDateAndTime } from 'src/utils/formatDate';
import './styles.scss';
interface IProps {
    country: string;
    brand: string;
    accountType: string;
    quote: any;
}

const QuoteInformation = ({ country, brand, accountType, quote }: IProps) => {
    const { payoffQuotesDetailInfo } = useLocalization();

    return (
        <section className='c-form-section quote-information-info'>
            <div className='c-form-section__content'>
                <div className='title'>
                    <h6>
                        <span className='c-section-heading__title-text u-mr-xxsmall section-title'>
                            {accountType == 'OperatingLease'
                                ? payoffQuotesDetailInfo.TITLE_LEASE
                                : payoffQuotesDetailInfo.TITLE_RETAIL}
                        </span>
                    </h6>
                </div>
                <div className='o-fieldset__row u-mt-large u-mb-large'>
                    <div className='o-layout'>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <div className='field-show'>
                                <span className='label'>
                                    {payoffQuotesDetailInfo.AMOUNT}
                                </span>
                                <span className='value'>
                                    {formatMoney(quote.quoteAmount)}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payoffQuotesDetailInfo.THROUGH_DATE}
                                </span>
                                <span className='value'>
                                    {formatDate(quote.goodThroughDate)}
                                </span>
                            </div>
                            <div className='field-show'>
                                <span className='label'>
                                    {payoffQuotesDetailInfo.DATE}
                                </span>
                                <span className='value'>
                                    {formatDateAndTime(quote.quoteDate)}
                                </span>
                            </div>
                            <div className='quote-note'>
                                {payoffQuotesDetailInfo.ADVISORY}
                            </div>
                        </div>
                        <div className='o-layout__item  u-1/2  u-1/1@l'>
                            <QuoteNotes
                                country={country}
                                brand={brand}
                                accountType={accountType}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuoteInformation;
